"use strict";

// ===== gsap =====
gsap.registerPlugin(ScrollTrigger);

// ===== lenis =====
const lenis = new Lenis({
  lerp: 0.1,
});

gsap.ticker.add((time) => lenis.raf(time * 1000));
gsap.ticker.lagSmoothing(0);
lenis.on("scroll", () => ScrollTrigger.update());

// ===== app Height =====
const appHeight = () => {
  document.documentElement.style.setProperty(
    "--app-height",
    `${document.documentElement.clientHeight}px`,
  );
};

// ===== parallax =====
const initParallax = ({ scale = 1.3, speed = 3 } = {}) => {
  const selector = document.querySelectorAll("[data-parallax] img");
  if (!selector) return;

  gsap.utils.toArray(selector).forEach((img) => {
    const travel = ((scale - 1) / 2) * 100 * speed;
    const isReverse = img.closest("[data-parallax]")?.dataset.parallax === "reverse";
    const fromY = isReverse ? travel / speed : -travel / speed;
    const toY   = isReverse ? -travel / speed : travel / speed;

    gsap.set(img, { scale, yPercent: fromY });

    gsap.to(img, {
      yPercent: toY,
      ease: "none",
      scrollTrigger: {
        trigger: img.closest("picture") ?? img,
        start: "top bottom",
        end: "bottom top",
        scrub: true,
        invalidateOnRefresh: true,
        markers: false,
      },
    });
  });
};

// ===== topic =====
const topicSwiper = new Swiper("[data-topic-swiper]", {
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  speed: 1000,
  breakpoints: {
    0: {
      slidesPerView: 1.231,
      spaceBetween: 24,
      allowTouchMove: true,
      draggable: true,
    },
    1025: {
      slidesPerView: "auto",
      spaceBetween: 30,
    },
  },
});

// ===== scroll target =====
document.querySelectorAll('a[href^="#"]').forEach((anchor) => {
  anchor.addEventListener("click", function (e) {
    e.preventDefault();

    const targetId = this.getAttribute("href");
    const target = document.querySelector(targetId);

    if (target) {
      lenis.scrollTo(target, {
        duration: 1.2,
        easing: (t) => 1 - Math.pow(1 - t, 3),
      });
    }
  });
});

// ===== Init =====


const init = () => {
  appHeight();
  initParallax();
  ScrollTrigger.clearScrollMemory("manual");
  ScrollTrigger.refresh();
};

// Resize smooth
let resizeTimeout;
const optimizedResize = () => {
  clearTimeout(resizeTimeout);
  resizeTimeout = setTimeout(() => {
    requestAnimationFrame(initParallax);
  }, 200);
};

// Use ResizeObserver with root margin
const resizeObserver = new ResizeObserver(optimizedResize);
resizeObserver.observe(document.documentElement, {
  box: "content-box",
});

window.addEventListener("resize", appHeight);
window.addEventListener("DOMContentLoaded", init);
